import { EnvironmentBannerLayout } from "@homebound/beam";
import { Outlet } from "react-router-dom";
import { ErrorBoundary } from "src/components/ErrorBoundary";
import { useEnvironmentBannerProps } from "src/routing/components/useEnvironmentBannerProps";

export function WorkflowPageLayout() {
  const environmentBanner = useEnvironmentBannerProps();

  return (
    <EnvironmentBannerLayout environmentBanner={environmentBanner}>
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
    </EnvironmentBannerLayout>
  );
}
